"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@hobt/constants");
exports.validatePostalCode = function (provinceCode, postalCode) {
    var postalCodeFirstCharacter = postalCode.charAt(0).toUpperCase();
    var validPostalCodeFirstLetter = {
        A: [constants_1.StatisticsCanadaProvinceID.NewfoundlandAndLabrador],
        B: [constants_1.StatisticsCanadaProvinceID.NovaScotia],
        C: [constants_1.StatisticsCanadaProvinceID.PrinceEdwardIsland],
        E: [constants_1.StatisticsCanadaProvinceID.NewBrunswick],
        G: [constants_1.StatisticsCanadaProvinceID.Quebec],
        H: [constants_1.StatisticsCanadaProvinceID.Quebec],
        J: [constants_1.StatisticsCanadaProvinceID.Quebec],
        K: [constants_1.StatisticsCanadaProvinceID.Ontario],
        L: [constants_1.StatisticsCanadaProvinceID.Ontario],
        M: [constants_1.StatisticsCanadaProvinceID.Ontario],
        N: [constants_1.StatisticsCanadaProvinceID.Ontario],
        P: [constants_1.StatisticsCanadaProvinceID.Ontario],
        R: [constants_1.StatisticsCanadaProvinceID.Manitoba],
        S: [constants_1.StatisticsCanadaProvinceID.Saskatchewan],
        T: [constants_1.StatisticsCanadaProvinceID.Alberta],
        V: [constants_1.StatisticsCanadaProvinceID.BritishColumbia],
        X: [constants_1.StatisticsCanadaProvinceID.NorthwestTerritories, constants_1.StatisticsCanadaProvinceID.Nunavut],
        Y: [constants_1.StatisticsCanadaProvinceID.Yukon],
    };
    if (validPostalCodeFirstLetter[postalCodeFirstCharacter] == null ||
        !validPostalCodeFirstLetter[postalCodeFirstCharacter].includes(provinceCode)) {
        return false;
    }
    return true;
};
